export default __webpack_public_path__ + "static/media/sharingIcon.df42f4c1.svg";